import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import Notification from '../../../../components/Notification/Notification';
import { getUserPageAuth } from '../../../../utils/page-auth';
import {
  itemRemoveRequest,
  userItemListRequest,
} from '../../../../redux/actions/app/userItemManageActions';
import useTranslation from '../../../../hooks/useTranslation';
import useSchemaUserItems from '../../../../schema/table-schema/useSchemaUserItems';
import BOTableUserItem from '../../../../components/Tables/BOTableUserItem';

function UserItemManageMain() {
  // -- component const --//
  // 페이지 제목
  const title = 'admin.app.fixAppData.user.item.title'; // '유저 아이템 관리';
  // const tHead = ['아이템 ID', '아이템 NAME', '수량', '만료시각', '삭제'];

  const { t } = useTranslation();
  const { schema } = useSchemaUserItems();

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 테이블
  const [list, setList] = useState();

  // 로딩
  const [isLoading, setIsLoading] = useState(false);

  // -- func & handler --//
  const fetchList = () => {
    // setIsLoading(true);

    dispatch(
      userItemListRequest({
        searchString: '',
        callback: (data) => {
          console.log('요청 결과: ', data);
          setList(data?.list);
          setIsLoading(false);
        },
        error: (e) => {
          console.error('Error:', e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
            setIsLoading(false);

        },
      }),
    );
  };

  const onDelete = (row) => {
    if (readOnly) {
      setNotificationMessage(`해당 페이지 권한 없음`);
      setShowNotification(true);
      return false;
    }

    const confirmed = window.confirm(
      `${row?.itemName}(id:${row?.itemId})를 삭제 하시겠습니까?`,
    );

    if (confirmed) {
      setIsLoading(true);

      dispatch(
        itemRemoveRequest({
          itemId: row?.itemId,
          callback: (data) => {
            console.log('요청 결과: ', data);
            setNotificationMessage(`${row?.itemId} 삭제 요청 성공`);
            setShowNotification(true);
            setIsLoading(false);
            fetchList();
          },
          error: (e) => {
            console.log(e);
            setNotificationMessage(e.toString());
            setShowNotification(true);
            setIsLoading(false);
          },
        }),
      );
    } else {
      setNotificationMessage('삭제 취소');
      setShowNotification(true);
    }
  };

  // -- react hooks --//
  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  useEffect(() => {
    fetchList();
  }, []);

  return (
    <div className="page">
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>

      <section className="topSection">
          <div className="leftSection">
              <p className="titleText">
                  {t(title)}
                  {readOnly ? '(읽기전용)' : ''}
              </p>
          </div>
      </section>

      <div className="spaceDiv10"/>

      <BOTableUserItem
        className={'user-item-table'}
        schema={schema}
        rows={list}
        loading={isLoading}
        onDelete={onDelete}
      />

      <div className="spaceDiv10"/>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default UserItemManageMain;
